import { render } from "./IconElectraESystem.vue?vue&type=template&id=3ee4b5e8"
import script from "./IconElectraESystem.vue?vue&type=script&lang=js"
export * from "./IconElectraESystem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__